import _ from 'underscore';

import left_menu_api from '@/component/admin-layout/1.0.0/component/left-menu/api';

export default {
    data() {
        return {};
    },
    computed: {
        entity_list() {
            const __this = this;
            return __this.$store.state.data_for_admin_layout.data_for_breadcrumb.entity_list;
        },
    },
    methods: {
        __init() {
            const __this = this;
            const meta = __this.$route.meta;
            if (!meta) return;
            const data_for_admin_layout = meta.data_for_admin_layout;
            if (!data_for_admin_layout) return;
            const data_for_breadcrumb = data_for_admin_layout.data_for_breadcrumb;
            if (!data_for_breadcrumb) return;
            const entity_list = data_for_breadcrumb.entity_list;
            if (!entity_list) return;
            if (!_.isArray(entity_list)) return;
            __this.$store.state.data_for_admin_layout.data_for_breadcrumb.entity_list = entity_list;
        },

        __btn_collapse_click() {
            const __this = this;
            left_menu_api.collapse();
        },
    },
    watch: {
        $route(pNewValue, pOldValue) {
            const __this = this;
            __this.__init();
        }
    },
    created() {
        const __this = this;
        __this.__init();
    },
}
